module.exports = __webpack_public_path__ + "img/escaner5.248f20bc.webp";